import { NgModule, ModuleWithProviders, ChangeDetectorRef } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FnI18nService } from './fn-i18.service';
import { FnTranslatePipe } from './fn-translate.pipe';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
export * from './fn-translate.pipe';


@NgModule({ declarations: [
        FnTranslatePipe
    ],
    exports: [
        TranslateModule,
        FnTranslatePipe
    ],
    schemas: [],
    imports: [
        TranslateModule],
         providers: [FnI18nService, TranslatePipe, provideHttpClient(withInterceptorsFromDi())

         ] })
export class FnTranslateModule {
    static forRoot(): ModuleWithProviders<FnTranslateModule> {
        return {
            ngModule: FnTranslateModule,
            providers: TranslateModule.forRoot().providers
        }
    }

    static forChild(): ModuleWithProviders<FnTranslateModule> {
        return {
            ngModule: FnTranslateModule,
            providers: TranslateModule.forChild().providers
        }
    }
}